<template>
  <div
    class="d-flex flex-column align-start justify-start tree-view"
    :style="{ maxHeight: `${maxHeight}px` }"
  >
    <TreeItem
      v-for="option in options"
      :key="option[idKey]"
      :option="option"
      :selected="modelValue"
      :level-has-children="anyHaveChildren"
      :id-key="idKey"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #option-label="{ option: slotOption }">
        <slot
          name="option-label"
          :option="slotOption"
        />
      </template>
    </TreeItem>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import TreeItem from '@/components/shared/TreeItem.vue';

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  maxHeight: {
    type: Number,
    default: 300,
  },
  idKey: {
    type: String,
    default: 'id',
  },
});

const anyHaveChildren = computed(() => props.options.some((option) => option.children?.length));

defineEmits(['update:modelValue']);
</script>

<style lang="less" scoped>
.tree-view {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
